import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { buildBreadcrumbs } from "@/lib/navigation";
import { cn } from "@/lib/utils";

/** PX-2: contextual trail so deep surfaces always show where the user is. */
export function Breadcrumbs({ className }: { className?: string }) {
  const { pathname } = useLocation();
  const crumbs = buildBreadcrumbs(pathname);
  if (crumbs.length < 2) return null;

  return (
    <nav aria-label="Breadcrumb" className={cn("mb-4", className)}>
      <ol className="flex flex-wrap items-center gap-1 text-xs text-muted-foreground">
        {crumbs.map((crumb, i) => (
          <li key={`${crumb.label}-${i}`} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="h-3 w-3 shrink-0 opacity-60" aria-hidden />}
            {crumb.to ? (
              <Link to={crumb.to} className="rounded transition-colors hover:text-foreground">
                {crumb.label}
              </Link>
            ) : (
              <span className="font-medium text-foreground" aria-current="page">{crumb.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
